export const DeleteIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1205_6021)">
      <path
        d="M8 8L16 16"
        stroke="#1F2D27"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 8L8 16"
        stroke="#1F2D27"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1205_6021">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
